"use strict";

var _taggedTemplateLiteral = require("/root/website/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.stepper = exports.range = exports.message = exports.line = exports.label = exports.inputDisabled = exports.input = exports.button = void 0;

var _stylitas = require("@creditas/stylitas");

var button = function button(_ref) {
  var theme = _ref.theme;
  return (0, _stylitas.css)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", ";\n  width: 48px;\n  height: 48px;\n  color: ", ";\n  background: transparent;\n  border: 0;\n  padding: 0;\n  outline: none;\n  overflow: hidden;\n  cursor: pointer;\n"])), _stylitas.utilities.typography.form(theme), _stylitas.utilities.palette.color(theme, 'secondary04'));
};

exports.button = button;

var input = function input(_ref2) {
  var theme = _ref2.theme,
      color = _ref2.color;
  return (0, _stylitas.css)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  ", ";\n  font-weight: 600;\n  width: calc(100% - 96px);\n  min-height: 100%;\n  border: 0;\n  padding: 0.5rem 0;\n  outline: none;\n  color: ", ";\n  border-bottom: 1px solid ", ";\n  text-align: center;\n  background: transparent;\n"])), _stylitas.utilities.typography.paragraph(theme), _stylitas.utilities.palette.color(theme, color), _stylitas.utilities.palette.color(theme, color));
};

exports.input = input;

var inputDisabled = function inputDisabled(_ref3) {
  var theme = _ref3.theme,
      disabled = _ref3.disabled;
  return disabled && (0, _stylitas.css)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    color: ", ";\n    border-bottom-color: ", ";\n  "])), _stylitas.utilities.palette.color(theme, 'neutral05'), _stylitas.utilities.palette.color(theme, 'neutral05'));
};

exports.inputDisabled = inputDisabled;

var label = function label(_ref4) {
  var theme = _ref4.theme;
  return (0, _stylitas.css)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  ", ";\n  width: calc(100% - 32px);\n  min-height: 32px;\n  color: ", ";\n  display: block;\n"])), _stylitas.utilities.typography.form(theme), _stylitas.utilities.palette.color(theme, 'neutral07'));
};

exports.label = label;

var line = function line(_ref5) {
  var theme = _ref5.theme;
  return (0, _stylitas.css)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  ", ";\n  width: 100%;\n  color: ", ";\n  display: block;\n"])), _stylitas.utilities.typography.support(theme), _stylitas.utilities.palette.color(theme, 'neutral07'));
};

exports.line = line;

var message = function message(_ref6) {
  var theme = _ref6.theme,
      color = _ref6.color;
  return (0, _stylitas.css)(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  ", ";\n  color: ", ";\n  margin-top: 16px;\n"])), _stylitas.utilities.typography.support(theme), _stylitas.utilities.palette.color(theme, color));
};

exports.message = message;
var range = (0, _stylitas.css)(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  width: 50%;\n  margin-top: 8px;\n  text-align: left;\n\n  &:nth-of-type(even) {\n    text-align: right;\n  }\n"])));
exports.range = range;
var stepper = (0, _stylitas.css)(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  min-width: 100%;\n  display: flex;\n  flex-wrap: wrap;\n"])));
exports.stepper = stepper;